

















































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import dayjs from 'dayjs'
import { MedicationInstructionPayload } from '@/api/medicationInstruction/types'
import InputGroup from '@/mixins/form/inputGroup'
import { getAllDatesOfMonth } from '@/utils/datetime'
import { DateString } from '@/types/utils'

const TODAY = dayjs()
const TODAY_OF_LAST_YEAR = TODAY.subtract(1, 'year')
const TODAY_OF_NEXT_YEAR = TODAY.add(1, 'year')

@Component({
  components: {
    SelectInput: () => import('@/components/common/inputs/SelectInput.vue')
  }
})
export default class VisitDateSelectInputGroup extends mixins(InputGroup) {
  @Prop(Object) inputs!: MedicationInstructionPayload

  visitDateEditing = false
  dayjs = dayjs

  inputVisitYear: number = this.inputVisitDateAsDayjs.year()
  inputVisitMonth: number = this.inputVisitDateAsDayjs.month() + 1
  inputVisitDay: number = this.inputVisitDateAsDayjs.date()

  get inputVisitDateAsDayjs() {
    return dayjs(this.inputs.visitDate)
  }

  get visitYearOptions() {
    const start = TODAY_OF_LAST_YEAR.year()
    const end = TODAY_OF_NEXT_YEAR.year()
    return [...new Array(end - start + 1)].map((_, i) => start + i)
  }

  get visitMonthOptions() {
    if (!this.inputVisitYear) {
      return []
    }
    return this.generateMonthOptions(this.inputVisitYear)
  }

  get visitDayOptions() {
    if (!this.inputVisitYear || !this.inputVisitMonth) {
      return []
    }
    return getAllDatesOfMonth(this.inputVisitYear, this.inputVisitMonth)
  }

  generateMonthOptions(selectedYear: number) {
    const lastYear = TODAY_OF_LAST_YEAR.year()
    const nextYear = TODAY_OF_NEXT_YEAR.year()
    const thisMonth = TODAY.month() + 1

    if (selectedYear === lastYear) {
      return [...new Array(12 - thisMonth)].map((_, i) => i + thisMonth + 1)
    }

    if (selectedYear === nextYear) {
      return [...new Array(thisMonth)].map((_, i) => i + 1)
    }

    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  }

  handleChangeVisitYear() {
    if (this.visitMonthOptions.indexOf(this.inputVisitMonth) === -1) {
      this.inputVisitMonth = this.visitMonthOptions[0]
      this.inputVisitDay = this.visitDayOptions[0]
    } else if (
      !this.inputVisitDay ||
      this.visitDayOptions.indexOf(this.inputVisitDay) === -1
    ) {
      this.inputVisitDay = this.visitDayOptions[0]
    }
  }

  handleChangeVisitMonth() {
    if (this.visitDayOptions.indexOf(this.inputVisitDay) === -1) {
      this.inputVisitDay = this.visitDayOptions[0]
    }
  }

  get selectedVisitDate() {
    return dayjs(
      new Date(
        this.inputVisitYear,
        this.inputVisitMonth - 1,
        this.inputVisitDay
      )
    ).format('YYYY-MM-DD') as DateString
  }

  handleClickVisitDateEdit() {
    this.visitDateEditing = true
    this.$emit('pending', true)
  }

  handleClickVisitDateFix() {
    this.visitDateEditing = false
    this.$set(this.inputs, 'visitDate', this.selectedVisitDate)
    this.$emit('pending', false)
  }
}
